import React, { useEffect, useState } from 'react'
import { Nav, Navbar, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useAuth } from '../auth/useAuth'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Notifications from '../menus/Notifications'
import { Calendar, LayoutDashboard, PawPrint } from 'lucide-react'

export default function MenuMovil({ rol }) {
	const { t } = useTranslation()
	const { clientauth, logoutClient } = useAuth()
    const {pathname} = useLocation()

	const { notifications } = useSelector(state => state.notifications)
	const [showCanvas, setShowCanvas] = useState(false)
	const [showEvents, setShowEvents] = useState(false)

	const toggleEvents = () => {
		setShowEvents(prevState => !prevState);
	}

	const closeEvents = () => {
		if (showEvents){
            setShowEvents(false)
        }
	}

	return (
		<>
			<Navbar fixed="bottom" id="menu-movil" className='d-block d-sm-none'>
				<Nav className="w-100 d-flex justify-content-between px-3">
					<Nav.Item onClick={closeEvents}>
                        <Nav.Link as={Link} to={`/${t("url.breeder.breeder")}/${t("url.breeder.dashboard")}`} className={pathname.includes(`/${t("url.breeder.breeder")}/${t("url.breeder.dashboard")}`) ? 'active' : ''}>
                            <LayoutDashboard size={22} />
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item onClick={closeEvents}>
                        <Nav.Link as={Link} to={`/${t("url.breeder.breeder")}/${t("url.breeder.calendar")}`} className={pathname.includes(`/${t("url.breeder.breeder")}/${t("url.breeder.calendar")}`) ? 'active' : ''}>
                            <Calendar size={22} />
                        </Nav.Link>
                    </Nav.Item>
					<Nav.Item>
						<Nav.Link onClick={toggleEvents}>
							<PawPrint size={22} />
						</Nav.Link>
					</Nav.Item>
				</Nav>
			</Navbar>

			{/* Menú flotante de eventos */}
			{showEvents && (
				<div className="floating-event-menu">
					<ul className="submenu">
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/birth`} onClick={() => setShowEvents(false)}>{t('menus.event_birth')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/acquisition`} onClick={() => setShowEvents(false)}>{t('menus.event_acquisition')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/death`} onClick={() => setShowEvents(false)}>{t('menus.event_death')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/sacrifice`} onClick={() => setShowEvents(false)}>{t('menus.event_sacrifice')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/desvieje`} onClick={() => setShowEvents(false)}>{t('menus.event_desvieje')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/sale`} onClick={() => setShowEvents(false)}>{t('menus.event_sale')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/movement`} onClick={() => setShowEvents(false)}>{t('menus.event_movement')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/review`} onClick={() => setShowEvents(false)}>{t('menus.event_review')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/reviewMark`} onClick={() => setShowEvents(false)}>{t('menus.event_reviewMark')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/status`} onClick={() => setShowEvents(false)}>{t('menus.event_status')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/heat`} onClick={() => setShowEvents(false)}>{t('menus.event_heat')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/birthProcess`} onClick={() => setShowEvents(false)}>{t('menus.event_birthProcess')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/abort`} onClick={() => setShowEvents(false)}>{t('menus.event_abort')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/weaning`} onClick={() => setShowEvents(false)}>{t('menus.event_weaning')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/weight`} onClick={() => setShowEvents(false)}>{t('menus.event_weight')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/insemination`} onClick={() => setShowEvents(false)}>{t('menus.event_insemination')}</Link></li>
						<li><Link to={`/${t("url.breeder.breeder")}/${t("url.breeder.event")}/${t("url.breeder.register")}/semental`} onClick={() => setShowEvents(false)}>{t('menus.event_semental')}</Link></li>
					</ul>
				</div>
			)}
			<Notifications showCanvas={showCanvas} setShowCanvas={setShowCanvas} />
		</>
	)
}

